module.exports = __webpack_public_path__ + "img/order-image.7d341983.png";